import { Component, ViewEncapsulation } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { BlockedService } from '../../models/service';
import { UserService } from '../../services/user.service';
import { TranslationService } from '../../services/translation.service';

@Component({
	selector: 'copo-blocked-services-alert',
	templateUrl: './blocked-services-alert.component.html',
	styleUrl: './blocked-services-alert.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgFor, NgIf, MatIconModule, MatButtonModule, TranslateModule]
})
export class BlockedServicesAlertComponent {
	constructor(
		private readonly userService: UserService,
		private readonly router: Router,
		private readonly translationService: TranslationService
	) {}

	get blockedServices(): BlockedService[] | undefined {
		return this.userService.user.blockedServices;
	}

	get blockedCount(): number {
		return this.blockedServices?.length ?? 0;
	}

	get introMessage(): string {
		if (this.blockedCount === 0) {
			return '';
		}
		const key = this.blockedCount === 1
			? 'blocked-service-alert.singular'
			: 'blocked-service-alert.plural';
		const raw = this.translationService.getTR(key, { service: '', services: '' });
		return raw.replace(/[:：]\s*$/, '').trim();
	}

	async refresh() {
		try {
			await this.userService.updateUserData();
		} catch (err) {
			console.error('error while refreshing user data for blocked services alert', err);
			return;
		}
		const path = this.router.url;
		await this.router.navigate(['redirect'], { queryParams: { path }, replaceUrl: true });
	}
}
